import { Input } from "./text-input-base.styles"

const TextInputBase = (props) => {
  return <Input {...props} aria-label={props.ariaText} />
}

export default TextInputBase
